var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('h4',[_vm._v("关于AI胎心监护模型训练的临床数据收集调查问卷")]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }